import { render, staticRenderFns } from "./ZonesServices.vue?vue&type=template&id=0465e671&scoped=true&"
import script from "./ZonesServices.vue?vue&type=script&lang=js&"
export * from "./ZonesServices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0465e671",
  null
  
)

export default component.exports